import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';
import { useSelector, useDispatch } from 'react-redux';
import * as NavigationActions from '../../store/navigation/actions';
import { BackButton, Content, Logo, LogoContainer, TitleText, TitleTextContainer } from './styles';
var TopNavigation = React.forwardRef(function (props, ref) {
    var showLogo = props.showLogo, showBackButton = props.showBackButton, title = props.title, headerPadding = props.headerPadding, headerTransparent = props.headerTransparent, oddStepName = props.oddStepName;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var theme = useSelector(function (state) { return state.theme; }).theme;
    var handleBackClick = function () {
        dispatch(NavigationActions.setAllowBackNavigation(true));
        navigate(-1);
        setTimeout(function () { return dispatch(NavigationActions.setAllowBackNavigation(false)); }, 50);
    };
    return (React.createElement(Content, { ref: ref, hPadding: headerPadding, style: headerTransparent ? { backgroundColor: 'transparent' } : {} },
        (showLogo && theme.logo) && (React.createElement(LogoContainer, null,
            React.createElement(Logo, null))),
        title ? React.createElement(TitleTextContainer, { oddStepName: oddStepName },
            React.createElement(TitleText, { style: { color: theme.buttonContentColor } }, title)) : null,
        showBackButton && (React.createElement(BackButton, { onClick: handleBackClick },
            React.createElement(FiChevronLeft, { color: theme.buttonContentColor, size: 24 })))));
});
export default TopNavigation;
